import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    rawMaterialCategories: [],
    total: 0,
    page: 1,
    pages: 1,
    isLoading: false
};

const rawMaterialCategorySlice = createSlice({
    name: "rawMaterialCategory",
    initialState,
    reducers: {
        setRawMaterialCategories: (state, action) => {
            state.rawMaterialCategories = action.payload.data;
            state.total = action.payload.total;
            state.page = action.payload.page;
            state.pages = action.payload.pages;
        },
        addRawMaterialCategory: (state, action) => {
            state.rawMaterialCategories.unshift(action.payload);
        },
        updateRawMaterialCategory: (state, action) => {
            const index = state.rawMaterialCategories.findIndex(
                (item) => item._id === action.payload._id
            );
            if (index !== -1) {
                state.rawMaterialCategories[index] = action.payload;
            }
        },
        deleteRawMaterialCategory: (state, action) => {
            state.rawMaterialCategories = state.rawMaterialCategories.filter(
                (item) => item._id !== action.payload
            );
        },
        setLoading: (state, action) => {
            state.isLoading = action.payload;
        },
    }
});

export const {
    setRawMaterialCategories,
    addRawMaterialCategory,
    updateRawMaterialCategory,
    deleteRawMaterialCategory,
    setLoading
} = rawMaterialCategorySlice.actions;

export const RawMaterialCategoryReducer = rawMaterialCategorySlice.reducer;
